import React from "react";
import JoinTheWave from "../../assets/images/JoinTheWave.jpeg";
import JoinTheConversation from "../../assets/images/JoinTheConversation.jpeg";
import { Fade } from "react-reveal";
const Register = () => {
  return (
    <div className="flex flex-col justify-center items-center mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24">
      <p className="font-['FuturaExtraBold'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl text-[#00693A]">
        <Fade top>REGISTRATION</Fade>
      </p>
      <Fade bottom>
        <div className="flex flex-col sm:flex-row justify-center items-center mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24">
          <img
            src={JoinTheWave}
            alt="Join The Wave"
            className="h-[200px] w-[90%] sm:h-[300px] sm:w-[350px] md:h-[350px] md:w-[400px] lg:h-[400px] lg:w-[550px] xl:h-[550px] xl:w-[700px] 2xl:h-[650px] 2xl:w-[1000px]"
          />

          <div className="flex flex-col shadow-2xl my-6 sm:my-8 md:my-10 lg:my-12 xl:my-16 2xl:my-24 sm:-ml-10 md:-ml-12 lg:-ml-20 xl:-ml-32 2xl:-ml-44 bg-[#ffffff] p-2 md:p-4 mx-12 sm:mx-1 -mt-12 sm:mt-1">
            <p className="text-sm sm:text-md md:text-lg p-1 sm:p-2 md:p-3 md:mt-3 lg:text-lg lg:p-4 lg:mt-4 xl:text-2xl 2xl:text-3xl xl:p-6 xl:mt-10 2xl:p-8 2xl:mt-12">
              <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl text-[#00693A] font-['FuturaExtraBold'] p-1 md:pb-2 lg:pb-3 xl:pb-6 2xl:pb-8 ">
                Join The Wave
              </p>
              {/* You’ve got the passion, we’ve got the platform! If you are willing
              to take action and drive change in our community, join the
              Lebanese Green Wave and start making a difference. Click here if
              you would like to join our team to help us grow. */}
              If you've got the passion and would like to join forces in driving
              change in our community, join our team and let's make a
              difference! Click here if you would like to join us:
            </p>
            <button
              onClick={(e) => {
                e.preventDefault();
                window.open("https://forms.gle/qY3bFJNwNtFzvHfy8");
              }}
              className="font-['FuturaExtraBold'] rounded-3xl shadow-2xl bg-[#008AC8] text-white px-2 sm:px-4 md:px-6 lg:px-8 xl:px-10 py-1 sm:py-2 md:py-3 lg:py-4 xl:py-6 text-xs sm:text-sm md:text-md lg:text-lg xl:text-2xl 2xl:text-3xl self-end mx-3 lg:mx-4 xl:mx-6 2xl:mx-8"
            >
              Sign Up
            </button>
          </div>
        </div>
      </Fade>
      <Fade bottom>
        <div className="flex flex-col sm:flex-row justify-center items-center mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24">
          <img
            src={JoinTheConversation}
            alt="Join The Wave"
            className="block sm:hidden h-[200px] w-[90%] sm:h-[300px] sm:w-[350px] md:h-[350px] md:w-[400px] lg:h-[400px] lg:w-[550px] xl:h-[550px] xl:w-[700px] 2xl:h-[650px] 2xl:w-[1000px] -scale-x-100"
          />

          <div className=" flex flex-col shadow-2xl my-6 sm:my-8 md:my-10 lg:my-12 xl:my-16 2xl:my-24 sm:-mr-10 md:-mr-12 lg:-mr-20 xl:-mr-32 2xl:-mr-44 bg-[#ffffff] p-2 md:p-4 mx-12 sm:mx-1 -mt-12 sm:mt-1 relative z-20">
            <p className="text-sm sm:text-md md:text-lg p-1 sm:p-2 md:p-3 md:mt-3 lg:text-lg lg:p-4 lg:mt-4 xl:text-2xl 2xl:text-3xl xl:p-6 xl:mt-10 2xl:p-8 2xl:mt-12 ">
              <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl text-[#00693A] font-bold p-1 md:pb-2 lg:pb-3 xl:pb-6 2xl:pb-8 font-['FuturaExtraBold']">
                Join The Conversation
              </p>
              {/* Are you an avid supporter of a cause? Do you have an overflow of
              experience that you’d like to share with the local and
              international community? Let us know, and let’s plan for a
              discussion! */}
              Are you an activist/professional and have experience that you
              would like to share with the community? Let us know, and click
              here if you would like to have a discussion!
            </p>
            <button
              onClick={(e) => {
                e.preventDefault();
                window.open("https://forms.gle/xnRGcjvrk43neTnH6");
              }}
              className="font-['FuturaExtraBold'] rounded-3xl shadow-2xl bg-[#008AC8] text-white px-2 sm:px-4 md:px-6 lg:px-8 xl:px-10 py-1 sm:py-2 md:py-3 lg:py-4 xl:py-6 text-xs sm:text-sm md:text-md lg:text-lg xl:text-2xl 2xl:text-3xl self-end mx-3 lg:mx-4 xl:mx-6 2xl:mx-8"
            >
              Sign Up
            </button>
          </div>
          <img
            src={JoinTheConversation}
            alt="Join The Wave"
            className="hidden sm:block h-[200px] w-[200px] sm:h-[300px] sm:w-[350px] md:h-[350px] md:w-[400px] lg:h-[400px] lg:w-[550px] xl:h-[550px] xl:w-[700px] 2xl:h-[650px] 2xl:w-[1000px] -scale-x-100"
          />
        </div>
      </Fade>
    </div>
  );
};

export default Register;
